import React, { useRef } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import mainengine from '../../../../assets/images/engine/main_engine-removebg.png';

const MainEngineSlider = () => {
  const containerRef = useRef(null);
  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);
  const scale = useMotionValue(1);
  const brightness = useMotionValue(100);
  
  const highlightColor = useTransform(
    [rotateX, rotateY],
    ([rx, ry]) => `hsl(${200 + Math.abs(rx * 5 + ry * 5)}, 80%, 90%)`
  );

  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    
    animate(rotateX, y * 15);
    animate(rotateY, -x * 15);
    // animate(scale, 1.05);
    // animate(brightness, 120);
  };

  const handleMouseLeave = () => {
    animate(rotateX, 0);
    animate(rotateY, 0);
    animate(scale, 1);
    animate(brightness, 100);
  };

  return (
    <div className="flex h-full items-center justify-center bg-white rounded-2xl shadow-xs border border-gray-100 p-5">
      <div className="relative rounded-2xl cursor-pointer transition-all duration-300 h-[100%]">
        <motion.div
          ref={containerRef}
          className="relative"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{ cursor: 'pointer', height: '100%', display: 'flex', alignItems: 'center' }}
        >
          {/* Main image with 3D effects - Modified to reduce blur */}
          <motion.img
            src={mainengine}
            alt="Marine Diesel Engine"
            className="max-w-full h-auto object-contain"
            style={{
              rotateX,
              rotateY,
              scale,
              filter: useTransform(brightness, (b) => `brightness(${b}%)`), // Removed drop-shadow
              transformStyle: 'preserve-3d',
              transformPerspective: 2000, // Increased perspective
              backfaceVisibility: 'hidden',
              willChange: 'transform' // Optimizes for hardware acceleration
            }}
          />
          
          {/* Dynamic blue highlight overlay */}
          <motion.div
            className="absolute inset-0 pointer-events-none mix-blend-soft-light"
            style={{
              background: highlightColor,
              opacity: useTransform(
                [rotateX, rotateY],
                ([rx, ry]) => Math.min(0.25, (Math.abs(rx) + Math.abs(ry)) / 80)
              ),
            }}
          />
          
          {/* Enhanced reflection effect */}
          <motion.div
            className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none"
            style={{
              opacity: useTransform(
                [rotateX, rotateY],
                ([rx, ry]) => Math.min(0.4, (Math.abs(rx) + Math.abs(ry)) / 40)
              ),
              background: 'linear-gradient(to top, rgba(173,216,230,0.5), transparent)',
              maskImage: 'linear-gradient(to top, black, transparent)',
            }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default MainEngineSlider;